import { useState, useCallback } from 'react';

export const usePopupVisibility = () => {
  const [branchesOpen, setBranchesOpen] = useState(false);
  const [packagesOpen, setPackagesOpen] = useState(false);

  const toggleBranches = useCallback(() => {
    setBranchesOpen(currentState => !currentState);
    if (!branchesOpen) {
      setPackagesOpen(false);
    }
  }, [branchesOpen]);

  const togglePackages = useCallback(() => {
    setPackagesOpen(currentState => !currentState);
    if (!packagesOpen) {
      setBranchesOpen(false);
    }
  }, [packagesOpen]);

  const closeBranches = useCallback(() => {
    setBranchesOpen(false);
  }, []);

  const closePackages = useCallback(() => {
    setPackagesOpen(false);
  }, []);

  return {
    branchesOpen,
    packagesOpen,
    toggleBranches,
    togglePackages,
    closeBranches,
    closePackages,
  };
};